import { Container, Text } from './styles';

export const EmptyWindowDay = ({ text }: { text: string }) => (
  <Container>
    <Text>{text}</Text>
  </Container>
);
